import Cookies from 'js-cookie';
import { ApiResponse, http } from '@config/api';
import useSWR from 'swr';
import { useUsersStore } from 'services/users';

// The API returns the count directly in the data field: {"success":true,"data":3,"error":""}
// So we don't need a specific response type for the count

export const useUnreadOffersCount = () => {
	const { user } = useUsersStore();
	const userRole = user?.role?.toLowerCase() || '';
	const isFarmer = userRole === 'farmer';

	const fetcher = async (): Promise<number> => {
		const accessToken = Cookies.get('accessToken');
		if (!accessToken) {
			return 0;
		}

		try {
			// Call the appropriate API endpoint based on the user's role
			const endpoint = isFarmer ? 'farmer/count-unseen-offers' : 'specialist/count-unseen-offers';
			console.log(`Fetching unread offers count for ${userRole} from endpoint:`, endpoint);
			
			const response = await http.get<ApiResponse<number>>('requests', endpoint);
			console.log(`Unread offers count response for ${userRole}:`, response.data);
			
			// Since data is directly the number, we can just return it or default to 0
			return typeof response.data.data === 'number' ? response.data.data : 0;
		} catch (error) {
			console.error(`Error fetching unread offers count for ${userRole}:`, error);
			return 0;
		}
	};

	const { data, error, isLoading, mutate } = useSWR<number>(
		userRole ? `unread-offers-count-${userRole}` : null,
		fetcher,
		{
			refreshInterval: 30000, // Refetch every 30 seconds
			revalidateOnFocus: true, // Refetch when user gets back to the tab
			revalidateOnReconnect: true, // Refetch when internet connection is restored
			dedupingInterval: 5000, // Dedupe requests within 5 seconds
			errorRetryCount: 3, // Retry 3 times on error
			errorRetryInterval: 5000, // Wait 5 seconds between retries
		}
	);

	return {
		unreadOffersCount: data ?? 0,
		isLoading,
		error,
		mutate, // Expose mutate for manual refetching if needed
	};
}; 